import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  width: "100%",
};

export const onboardingContainer: CSSProperties = {
  ...container,
  border: `1px solid ${greys.borderGrey}`,
  borderRadius: 5,
  padding: "0 12px",
  "&.active": {
    border: `1px solid ${colors.green.lighter}`,
  },
};

const textField: CSSProperties = {
  width: "100%",
  margin: "10px 0",
};

export const styles = {
  container,
  onboardingContainer,
  textField,
};
